import DealerCardSkeleton from "./DealerCardSkeleton";

const DealersLoading = ({title}) => {
    return (
        <>
            <DealerCardSkeleton/>
            <DealerCardSkeleton/>
            <DealerCardSkeleton/>
        </>
    )
}

export default DealersLoading
